import { render, staticRenderFns } from "./CustomersCard.vue?vue&type=template&id=901faca8&"
import script from "./CustomersCard.vue?vue&type=script&lang=js&"
export * from "./CustomersCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomersCard.vue?vue&type=style&index=0&id=901faca8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports